import { chatHistoryBGColor, grayText } from 'globals/colors';

import { alertIcon } from 'globals/assets';

const styles = {
  container: {
    flex: '0 0 auto',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: chatHistoryBGColor,
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px 0 15px',
    height: '75px',
  },
  alertIcon: {
    backgroundPosition: 'center center',
    backgroundImage: `url("${alertIcon}")`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    minHeight: '20px',
    width: '20px',
    marginBottom: '5px',
  },
  text: {
    maxWidth: '67.666%',
    fontSize: '12px',
    color: grayText,
    textAlign: 'center',
    textTransform: 'uppercase',
    fontWeight: 500,
  },
};
export default styles;
